import { createApi } from '@reduxjs/toolkit/query/react';
import { uploadBaseQuery } from '@store/baseQuery';

// File upload response type
export interface UploadFileResponse {
  status: boolean;
  url: string;
}

// Files API for upload functionality
export const filesApi = createApi({
  reducerPath: "filesApi",
  baseQuery: uploadBaseQuery,
  tagTypes: ["Upload"],
  endpoints: (builder) => ({
    // Upload file
    uploadFile: builder.mutation<UploadFileResponse, FormData>({
      query: (formData) => ({
        url: "/upload_file",
        method: "POST",
        body: formData,
      }),
    }),
  }),
});

// Export hooks
export const {
  useUploadFileMutation,
} = filesApi;

// Export reducer
export default filesApi.reducer;